module.exports = __webpack_public_path__ + "img/audio.eb719ee8.svg";